import { createContext } from 'react';

export const IntegrationsContext = createContext();
